module.exports = __webpack_public_path__ + "static/media/home-service-slider-5.4f330cd1.jpg";